<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير كشف الموقوفين"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[
        name,
        desc,
        `تقرير كشف الموقوفين عن شهر ${convert_Month(month)}`,
      ]"
    >
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: ["month", "date", "name", "desc" ,"FilterDeparmentClassificationsIds","bankClassificationId"],
  data() {
    return {
      json_fields: {
        "ر.م": "num",
        "الرقم المالى": "financialNumber",
        "اسم الموظف": "employeeName",
        المصرف: "bankBranchName",
        "رقم الحساب": "accountNumber",
        بتاريخ: "suspentionDate",
        "سبب الإيقاف": "suspentionNote",
      },
    };
  },
  methods: {
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }

      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let schema = {
        MonthDate: this.month,
        BankClassificationId: this.bankClassificationId,

        FilterDeparmentClassificationsIds: this.FilterDeparmentClassificationsIds == "" ? null : this.FilterDeparmentClassificationsIds,
      };
      let res = await axios.patch(
        `${env.HR()}/api/SalariesReports/SuspendedEmployees`,
        schema,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      // for (let i = 0; i < result.data.data.items.length; i++) {
      //   let schema = {
      //     id: i + 1,
      //     financialNumber: result.data.data.items[i].financialNumber,
      //     employeeName: result.data.data.items[i].employeeName,
      //     bankBranchName: result.data.data.items[i].bankBranchName,
      //     accountNumber: result.data.data.items[i].accountNumber,
      //     suspentionDate: result.data.data.items[i].suspentionDate,
      //     // suspentionDate: result.data.data.items[i].suspentionDate,
      //     suspentionNote: result.data.data.items[i].suspentionNote,
      //   };
      //   this.staffReportData.push(schema);
      //   this.id_all = this.staffReportData.length;
      // }

      // // this.staffReportData = result.data.data.items;
      // this.name = result.data.data;
      res.data.data.items.forEach((item, i) => {
        item.num = i + 1;
      });

      // console.warn("res.data.data.items ::::", res.data.data.items);

      return res.data.data.items;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
</style>